import MalattieInfettive from "../";

const routes = [

    { name: "Malattie Infettive Configurazioni Uosd List", path: "/malattieinfettive/configurazioneuosd", component: MalattieInfettive.MalattieInfettiveConfigurazioneUosdListPage, meta: { title: "Lista Uosd" } },];

export default routes;
